import React, { JSX } from "react";

import './RydHeaderDialogBox.css';
import { normalizeClassName } from "../../render/renderUtils";

function RydHeaderDialogBox({
    children,
    closeCB
}: {
    children: JSX.Element,
    closeCB: () => void
}) {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [height, setHeight] = React.useState("0px");
    const [closing, setClosing] = React.useState(false);

    React.useEffect(() => {
        if (containerRef.current) {
            const fullHeight = containerRef.current.scrollHeight;
            requestAnimationFrame(() => {
                setHeight(`${fullHeight}px`);
            });
        }
    }, []);

    const handleClose = () => {
        setClosing(true);
        setHeight("0px");
    };

    const handleTransitionEnd = () => {
        if (closing) {
            closeCB();
        }
    };

    return (
        <div
            ref={containerRef}
            style={{
                height,
            }}
            className={normalizeClassName(["piano-roll-header-controls--param-edit", "header-dialog-box--opened"])}
            onTransitionEnd={handleTransitionEnd}
        >
            {children}
            <button onClick={handleClose}>Close</button>
        </div>
    );
}

export default RydHeaderDialogBox;